module.exports = function () {
const appBanner = `/demo/partials/AppBanner/AppBanner.html`;
return (`
<!--# if expr="$cookie_siteAppBanner!=1" -->
<!--# include virtual="${appBanner}" -->
<!--# endif -->
`)
};

